import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MaterialSwitch from '@material-ui/core/Switch';
import withStyles from '@material-ui/core/styles/withStyles';

function getStyledSwitch(colorType = 'primary') {
  return withStyles(theme => {
    let color = colorType.includes('#')
      ? colorType
      : theme.palette[colorType].main;
    return {
      root: {
        width: 28,
        height: 15,
        padding: 0,
        margin: 5,
        display: 'flex',
        overflow: 'visible',
      },
      switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
          transform: 'translateX(12px)',
          color: theme.palette.common.white,
          '& + $track': {
            opacity: 1,
            backgroundColor: color,
            borderColor: color,
          },
        },
      },
      thumb: {
        width: 12,
        height: 12,
        color: theme.palette.common.white,
        boxShadow: 'none',
      },
      track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.grey[500],
      },
      checked: {},
    };
  })(MaterialSwitch);
}

const Switch = ({
  checked = false,
  className = '',
  color = 'primary',
  disabled = false,
  label = '',
  placement = 'end',
  onChange = () => {},
  labelProps = {},
}) => {
  const SwitchComponent = getStyledSwitch(color);
  return (
    <FormControlLabel
      data-testid='switch-btn'
      control={
        <SwitchComponent
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
      }
      label={label}
      classes={{
        root: className,
        label: color.indexOf('#') === -1 ? `color-${color}` : color,
      }}
      labelPlacement={placement}
      {...labelProps}
    />
  );
};

export default Switch;
